import samtykkeActions from "./samtykkeActions";

export default samtykkeActions;
